export class BurgerMenu {
    constructor() {
        this.menu = document.querySelector('[data-entity="burger-menu"]');
        this.overlay = document.querySelector('[data-entity="black-screen-trigger"]');
        this.scroll = document.querySelectorAll('[data-scroll="scroll-lock-trigger"]');
        this.openBtn = document.querySelectorAll('[data-entity="burger-menu-open"]');
        this.closeBtn = document.querySelector('[data-entity="burger-menu-close"]');

        this.initializeMenu();
    }

    initializeMenu() {
        this.openBtn?.forEach((button) => button.addEventListener('click', () => this.openMenu()));
        this.closeBtn?.addEventListener('click', () => this.closeMenu());

        this.overlay?.addEventListener('click', () => {
            this.closeMenu();
        });
    }

    openMenu() {
        this.menu.classList.add('burger__active');
        this.overlay.classList.remove('visually-hidden');
        this.scroll.forEach((el) => el.classList.add('scroll-lock'));
    }

    closeMenu() {
        this.menu.classList.remove('burger__active');
        this.overlay.classList.add('visually-hidden');
        this.scroll.forEach((el) => el.classList.remove('scroll-lock'));
    }
}
